/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementPositionBaseContract} from '../../api/contracts/settlement-position-base.contract';
import {SettlementPositionModel} from './settlement-position.model';
import {CurrencyBaseContract} from '../../api/contracts/currency/currency-base.contract';


export class SettlementPositionMapper {
    static fromSettlementPositionBaseContractArray(input: SettlementPositionBaseContract[], currency: CurrencyBaseContract):
            SettlementPositionModel[] {
        return input?.map((element) => SettlementPositionMapper.fromSettlementPositionBaseContract(element, currency));
    }

    static fromSettlementPositionBaseContract(element: SettlementPositionBaseContract, currency: CurrencyBaseContract):
            SettlementPositionModel {
        let model: SettlementPositionModel;

        if (currency != null && element != null) {
            model = {
                blueFapiaoNumber: element.blueFapiaoNumber,
                deliveryNumber: element.deliveryNumber,
                salesDocument: element.salesDocument,
                comments: element.comments,
                quantity: element.quantity,
                materialsUnitNetCost: element.materialsUnitNetCost,
                materialsTotalNetCost: element.materialsTotalNetCost,
                taxRate: element.taxRate,
                materialsTotalGrossCost: element.materialsTotalGrossCost,
                teMinutesAmount: element.teMinutesAmount,
                teMinutesUnitCost: element.teMinutesUnitCost,
                teMinutesAdditionalCost: element.teMinutesAdditionalCost,
                teMinutesTotalCost: element.teMinutesTotalCost,
                currency: {
                    alphabeticCode: currency.alphabeticCode,
                    numericCode: currency.numericCode,
                    minorUnit: currency.minorUnit,
                    name: currency.name,
                }
            };
        }
        return model;
    }

}
